var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCarpenter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1_40210",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1_40210)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.4751 21.3C15.2918 21.4833 15.0793 21.625 14.8376 21.725C14.5959 21.825 14.3418 21.875 14.0751 21.875C13.8084 21.875 13.5501 21.825 13.3001 21.725C13.0501 21.625 12.8334 21.4833 12.6501 21.3L11.2501 19.9C11.0668 19.7167 10.9293 19.5125 10.8376 19.2875C10.7459 19.0625 10.6918 18.8333 10.6751 18.6C10.6584 18.3667 10.6876 18.1333 10.7626 17.9C10.8376 17.6667 10.9501 17.45 11.1001 17.25L11.2501 17.05L3.1001 5.4L7.0001 1.5L19.7251 14.225C19.9084 14.4083 20.0501 14.6208 20.1501 14.8625C20.2501 15.1042 20.3001 15.3583 20.3001 15.625C20.3001 15.8917 20.2501 16.15 20.1501 16.4C20.0501 16.65 19.9084 16.8667 19.7251 17.05L15.4751 21.3ZM12.6751 15.625L15.5001 12.825L7.0001 4.325L5.7001 5.625L12.6751 15.625ZM14.0751 19.875L18.3001 15.65L16.9001 14.225L12.6501 18.475L14.0751 19.875Z",
    fill: "#7F599D"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCarpenter);
export default __webpack_public_path__ + "static/media/carpenter.cceadf6641d6e7808d8bc6709dcc372f.svg";
export { ForwardRef as ReactComponent };